// extracted by mini-css-extract-plugin
export var button = "s_W";
export var buttonContent = "s_bm";
export var buttonInner = "s_2";
export var loading = "s_bp";
export var loadingContainer = "s_bn";
export var loadingSpinner = "s_8";
export var loadingText = "s_bb";
export var spin = "s_9";